export enum UploadMediaType {
  FILE = 'FILE',
  LINK = 'LINK',
  GONG_CALL = 'GONG_CALL',
  SALESLOFT_CALL = 'SALESLOFT_CALL',
}
